export default {
    general: {
        add:            'Ajouter',
        edit:           'Modifier',
        delete:         'Supprimer',
        cancel:         'Annuler',
        save:           'Enregistrer',
        confirm:        'Confirmer',
        confirm_action: 'Confirmer l\'action',
        sign_out:       'Déconnexion',
        more_info:      'Plus d\'informations',
        name:           'Nom',
        refresh:        'Actualiser',
        actions:        'Actions',
        status:         'État',
        details:        'Détails',
        type:           'Type',
        overview:       'Aperçu',
        settings:       'Paramètres',
    },
    brand: {
        product_name: 'NervusEye',
        product_line: 'MONITOR',
        vendor:       'by iT TEAM d.o.o.',
        tagline:      'Gestion des opérations réseau',
    },
    // Short labels for the navigation row; nav.* stays the full section name
    nav_short: {
        dashboard:     'Accueil',
        devices:       'Appareils',
        topology:      'Topologie',
        ipam:          'IPAM',
        documentation: 'Docs',
        security:      'Sécurité',
        syslog:        'Syslog',
        events:        'Événements',
        tools:         'Outils',
        sla:           'SLA',
        templates:     'Modèles',
        users:         'Utilisateurs',
        settings:      'Paramètres',
        about:         'À propos',
    },
    nav: {
        dashboard:      'Tableau de bord',
        devices:        'Appareils & Arborescence',
        topology:       'Topologie réseau',
        ipam:           'IPAM & Inventaire',
        security:       'Sécurité des ports & Rogue',
        syslog:         'Syslog & Traps SNMP',
        events:         'Pannes & Événements',
        sensors:        'Capteurs',
        administration: 'Administration',
        templates:      'Modèles',
        users:          'Gestion des utilisateurs',
        settings:       'Paramètres globaux',
        changelog:      'Journal des modifications',
        about:          'À propos & Aide',
    },
    common: {
        cancel: 'Annuler',
        close:  'Fermer',
    },
    languages: {
        en:              'English',
        hr:              'Hrvatski',
        sl:              'Slovenščina',
        de:              'Deutsch',
        fr:              'Français',
        change_language: 'Changer de langue',
    },
    status: {
        up:           'En ligne (UP)',
        down:         'Hors ligne (DOWN)',
        warning:      'Avertissement',
        acknowledged: 'Acquitté',
        paused:       'En pause',
        unknown:      'Inconnu',
    },
    dashboard: {
        title:                'Tableau de bord des opérations',
        subtitle:             'Télémétrie réseau en temps réel et santé de l\'infrastructure',
        total_devices:        'Total des appareils',
        online_devices:       'Appareils en ligne',
        warning_devices:      'Avertissement / Dégradé',
        offline_devices:      'Hors ligne / Critique',
        total_sensors:        'Capteurs actifs',
        network_health:       'Santé du réseau',
        all_systems_ok:       'Tous les appareils et capteurs surveillés sont opérationnels.',
        active_alerts:        'Alertes actives & Pannes',
        active_alerts_desc:   'Appareils et capteurs nécessitant une attention',
        recent_devices:       'Appareils d\'infrastructure surveillés',
        explore_tree:         'Ouvrir l\'arborescence',
        inspect:              'Inspecter',
        auto_refresh:         'Actualisation automatique',
        arrange_graphs:       'Modifier / Organiser les graphiques',
        done_arranging:       'Terminer l\'organisation',
        arrange_hint:         'Mode organisation : Ajoutez plusieurs graphiques, glissez-déposez les cartes ou utilisez les flèches.',
        grid_cols:            'Colonnes :',
        save_layout:          'Enregistrer la disposition',
        select_sensor_to_add: 'Sélectionner un capteur à ajouter...',
        add_graph:            'Ajouter un graphique',
        layout_saved:         'Disposition des graphiques enregistrée',
        pause_sensor:         'Mettre en pause',
        top_metrics_title:    'Performance & Top Hôtes',
        top_metrics_subtitle: 'Aperçus en temps réel par consommation des ressources, trafic et stabilité',
        widgets_active:       'actif(s)',
        top_cpu:              'Charge CPU maximale',
        top_cpu_desc:         'Appareils avec le plus fort pourcentage d\'utilisation du processeur',
        top_ram:              'Consommation RAM maximale',
        top_ram_desc:         'Appareils avec la plus grande utilisation de mémoire vive',
        top_uptime:           'Disponibilité & Temps de fonctionnement',
        longest_uptime:       'Plus longue disponibilité (Stabilité)',
        recently_rebooted:    'Récemment redémarrés',
        top_ping:             'Latence maximale / Ping',
        top_ping_desc:        'Appareils avec les temps de réponse réseau les plus élevés (RTT)',
        top_traffic:          'Trafic réseau le plus élevé',
        top_port_errors:      'Erreurs de port & Pertes de tampon',
        no_port_errors:       'Aucune erreur de port ou perte de tampon détectée',
        top_bgp:              'Sessions de peering BGP',
        top_temperature:      'Température & Matériel',
        top_storage:          'Top Stockage / Disque',
        view_mode_grid:       'Grille',
        view_mode_tabs:       'Onglets',
        customize_widgets:    'Personnaliser les widgets',
        hosts_ranked:         'hôtes classés',
        no_data:              'Aucune donnée',
    },
    tree: {
        search_placeholder: 'Rechercher appareils, IP, capteurs...',
        filter_all:         'Tous',
        total_items:        'éléments',
        no_nodes_found:     'Aucun élément correspondant',
        add_group:          'Ajouter un groupe',
        add_folder:         'Ajouter un dossier',
        add_device:         'Ajouter un appareil',
        add_sensor:         'Ajouter un capteur',
        root_title:         'Arborescence de l\'infrastructure',
        back_to_tree:       'Retour à l\'arborescence',
    },
    devices: {
        title:                'Explorateur d\'appareils',
        add_device:           'Ajouter un appareil',
        edit_device:          'Modifier l\'appareil',
        delete_device:        'Supprimer l\'appareil',
        confirm_delete:       'Êtes-vous sûr de vouloir supprimer cet appareil et tous ses capteurs ?',
        name:                 'Nom de l\'appareil',
        name_placeholder:     'ex. Core-Switch-01',
        hostname_ip:          'Nom d\'hôte / IP',
        polling_interval:     'Intervalle d\'interrogation (s)',
        snmp_enabled:         'Activer SNMP',
        snmp_enabled_hint:    'Interroger les métriques MIB et découvrir automatiquement les interfaces',
        snmp_version:         'Version SNMP',
        snmp_port:            'Port SNMP',
        snmp_community:       'Chaîne de communauté',
        poll_now:             'Interroger maintenant',
        polling_started:      'Interrogation manuelle démarrée',
        snmp_walk:            'SNMP Walk',
        snmp_walk_title:      'Diagnostic SNMP Walk',
        run_walk:             'Lancer le Walk',
        walking_mibs:         'Parcours de l\'arborescence OID...',
        no_walk_results:      'Aucun résultat OID retourné',
        device_details:       'Détails de l\'appareil',
        device_sensors:       'Capteurs configurés',
        sensors_count:        'Capteurs',
        vendor:               'Fabricant',
        model:                'Modèle',
        last_polled:          'Dernière interrogation',
        no_devices_in_folder: 'Aucun appareil dans ce groupe/dossier',
        select_node_hint:     'Sélectionnez un groupe, un dossier ou un appareil dans l\'arborescence de gauche pour afficher les détails.',
    },
    discovery: {
        title:               'Découverte des interfaces & Autodécouverte',
        scan_interfaces:     'Scanner les interfaces',
        run_autodiscovery:   'Lancer l\'autodécouverte complète',
        select_all:          'Tout sélectionner',
        deselect_all:        'Tout désélectionner',
        add_selected:        'Ajouter la sélection comme capteurs',
        scanning_hint:       'Interrogation SNMP ifTable / ifXTable...',
        no_interfaces:       'Aucune interface trouvée. Assurez-vous que SNMP répond sur l\'appareil.',
        description:         'Description / Alias',
        speed:               'Vitesse',
        discover_interfaces: 'Découvrir les interfaces',
    },
    sensors: {
        add_sensor:          'Ajouter un capteur',
        edit_sensor:         'Modifier le capteur',
        edit_sensor_title:   'Modifier les paramètres du capteur',
        type:                'Type de capteur',
        name:                'Nom du capteur',
        name_placeholder:    'ex. Latence Ping',
        interval:            'Intervalle (s)',
        enabled:             'Capteur actif / activé',
        enabled_hint:        'Lorsque désactivé, le collecteur suspend l\'interrogation de ce capteur',
        oid:                 'OID SNMP',
        interface_index:     'Index d\'interface',
        last_reading:        'Dernière lecture',
        last_checked:        'Dernière vérification',
        confirm_delete:      'Êtes-vous sûr de vouloir supprimer ce capteur ?',
        no_sensors_assigned: 'Aucun capteur assigné à cet appareil pour l\'instant',
    },
    metrics: {
        title:      'Télémétrie en direct & Métriques',
        current:    'Actuel',
        avg:        'Moyenne',
        min:        'Min',
        max:        'Max',
        no_data:    'Aucune mesure disponible pour cette période',
    },
    templates: {
        title:                'Modèles SNMP & MIBs',
        subtitle:             'Modèles de performance et profils standard de fabricants',
        add_template:         'Ajouter un modèle',
        edit_template:        'Modifier le modèle',
        import_template:      'Importer des modèles',
        import_template_hint: 'Collez la structure JSON pour importer des modèles en lot.',
        import_mib:           'Importer un MIB',
        import_mib_hint:      'Téléversez un fichier MIB RFC ou fournisseur pour peupler les catalogues OID.',
        export_all:           'Tout exporter (JSON)',
        export:               'Exporter',
        search_placeholder:   'Rechercher des modèles par nom, fabricant...',
        templates_count:      'modèles',
        no_templates_found:   'Aucun modèle SNMP trouvé',
        template_oids:        'OIDs configurés dans le modèle',
        add_oid:              'Ajouter un OID',
        no_oids_added:        'Aucun OID défini dans ce modèle pour l\'instant.',
    },
    users: {
        title:            'Comptes utilisateurs',
        subtitle:         'Gérer les accès opérateurs et les autorisations de rôle',
        add_user:         'Ajouter un utilisateur',
        edit_user:        'Modifier l\'utilisateur',
        accounts:         'Comptes enregistrés',
        username:         'Nom d\'utilisateur',
        role:             'Rôle',
        password:         'Mot de passe',
        change_password:  'Changer de mot de passe',
        old_password:     'Mot de passe actuel',
        new_password:     'Nouveau mot de passe',
        confirm_password: 'Confirmer le nouveau mot de passe',
        no_users_found:   'Aucun compte utilisateur trouvé',
    },
    settings: {
        title:                 'Paramètres du système',
        subtitle:              'Configuration globale, journaux d\'audit et sauvegarde de la base',
        general_tab:           'Général',
        general_preferences:   'Préférences générales',
        appearance:            'Apparence',
        appearance_info:       'Thème de couleurs de ce navigateur. Les pages, menus et onglets restent les mêmes ; seuls les couleurs, bordures et la police changent.',
        theme_company:         'Entreprise',
        theme_company_desc:    'Couleurs NervusEye : gris zinc et orange',
        theme_classic:         'Classique',
        theme_classic_desc:    'Le premier style ZeroNMS : anthracite, ardoise et bleu',
        root_node_name:        'Nom d\'affichage du nœud racine',
        default_traffic_unit:  'Unité de bande passante par défaut',
        audit_logs:            'Journaux d\'audit et modifications',
        timestamp:             'Horodatage',
        action:                'Action exécutée',
        backup_recovery:       'Sauvegarde & Récupération',
        console_tab:           'Applications console',
        console_downloads:     'Téléchargement de la console',
        console_info:          'Application de bureau native qui se connecte à plusieurs serveurs NervusEye MONITOR à la fois et affiche leurs arborescences, alarmes et historiques de capteurs.',
        console_req_macos:     'macOS 14 Sonoma ou ultérieur, Apple silicon et Intel',
        console_req_windows:   'Windows 10 (1809) ou ultérieur, 64 bits',
        console_req_android:   'Android 10 ou ultérieur',
        console_ios_note:      'iPhone et iPad : la console est distribuée via TestFlight ; demandez une invitation à votre administrateur.',
        console_build:         'Build',
        console_size:          'Taille',
        console_published:     'Publié',
        console_download:      'Télécharger {file}',
        console_unavailable:   'Pas encore disponible',
        console_not_published: 'Aucun programme d’installation n’a encore été publié sur ce serveur.',
        console_loading:       'Chargement...',
        console_connect:       'Se connecter à ce serveur',
        console_server_address:'Adresse du serveur',
        console_step_install:  'Installez la console et ouvrez-la.',
        console_step_add:      'Choisissez Add Server et collez l’adresse du serveur ci-dessus.',
        console_step_login:    'Connectez-vous avec votre identifiant et mot de passe NervusEye MONITOR.',
        run_backup:            'Lancer la sauvegarde maintenant',
        restore:               'Restaurer',
        notifications_tab:     'Alertes & Notifications',
        notifications_title:   'Canaux d\'alerte et de notification',
        telegram_title:        'Bot d\'alerte Telegram',
        telegram_desc:         'Envoyez des notifications push instantanées vers votre chat privé ou groupe IT Telegram.',
        telegram_enable:       'Activer les alertes Telegram',
        telegram_bot_token:    'Jeton du bot Telegram',
        telegram_token_help:   "Obtenir auprès de {'@'}BotFather sur Telegram (ex. 123456789:ABCdefGhI...)",
        telegram_chat_id:      'ID de chat Telegram',
        telegram_chat_help:    'ID du chat ou groupe cible (ex. -100123456789)',
        telegram_test_btn:     'Envoyer une alerte test Telegram',
        webhook_title:         'Intégration Webhook',
        webhook_desc:          'Diffusez les alertes JSON vers Discord, Slack, Microsoft Teams ou un point de terminaison HTTP personnalisé.',
        webhook_enable:        'Activer les alertes Webhook',
        webhook_url:           'URL du Webhook',
        webhook_url_help:      'URL de webhook entrant (ex. Discord ou Slack)',
        webhook_test_btn:      'Envoyer une alerte test Webhook',
        trigger_rules_title:   'Règles de déclenchement des alertes',
        notify_down:           'Notifier en cas de panne / DOWN',
        notify_down_help:      'Envoyer une alerte immédiate lorsqu\'un équipement ou capteur passe à l\'état DOWN',
        notify_warning:        'Notifier en cas d\'avertissement / WARNING',
        notify_warning_help:   'Envoyer une alerte lorsqu\'un capteur dépasse le seuil d\'avertissement',
        notify_recovery:       'Notifier en cas de rétablissement / RECOVERY',
        notify_recovery_help:  'Envoyer une notification de rétablissement lorsque le composant redevient UP',
    },
    events: {
        title:            'Historique des pannes & événements',
        subtitle:         'Journal chronologique des pannes de réseau, alertes et rétablissements',
        tab:              'Pannes & Événements',
        total_outages:    'Total des pannes',
        active_outages:   'Pannes en cours',
        resolved_outages: 'Incidents résolus',
        warnings:         'Événements d\'alerte',
        filter_device:    'Rechercher équipement, IP ou capteur...',
        filter_status:    'État',
        filter_resolved:  'Statut',
        all_statuses:     'Tous les états',
        all_states:       'Tous les statuts',
        active_only:      'Incidents en cours',
        resolved_only:    'Résolus uniquement',
        started_at:       'Débuté à',
        ended_at:         'Terminé à',
        duration:         'Durée',
        component:        'Composant / Capteur',
        reason:           'Cause racine / Message',
        active:           'Panne active',
        resolved:         'Résolu',
        no_events:        'Aucun incident enregistré selon les critères.',
        ongoing:          'En cours',
    },
    layout: {
        open_menu:  'Ouvrir le menu',
        more:       'Plus',
        close_menu: 'Fermer le menu',
    },
    color_mode: {
        switch_to_light: 'Passer au mode clair',
        switch_to_dark:  'Passer au mode sombre',
    },
    errors: {
        generic_error: 'Une erreur s\'est produite',
        invalid_data:  'Données invalides',
        not_found:     'Introuvable',
        unauthorized:  'Non autorisé',
        on_add:        'Erreur lors de l\'ajout',
        on_edit:       'Erreur lors de la mise à jour',
    },
    success: {
        add:  'Ajouté avec succès',
        edit: 'Mis à jour avec succès',
    },
    validation: {
        required: 'Ce champ est obligatoire',
        email:    'Adresse e-mail invalide',
    },
    syslog: {
        title:               'Récepteur central Syslog & Traps SNMP',
        subtitle:            'Collecte Syslog UDP 514 et Traps SNMP UDP 162 en temps réel, analyse des mnémoniques Cisco et alertes instantanées',
        live_Pause:          'Flux en direct actif',
        paused:              'Flux en pause',
        simulate:            'Simuler un événement / Trap',
        clear_old:           'Purger les anciens journaux',
        total_messages:      'Total des événements',
        last_24h:            'Événements (24h)',
        critical_24h:        'Critiques / Alertes (24h)',
        warnings_24h:        'Avertissements (24h)',
        syslog_vs_trap:      'Syslog vs Traps SNMP',
        top_categories:      'Catégories principales :',
        search_placeholder:  'Rechercher message, mnémonique (%LINK-3-UPDOWN), IP, équipement...',
        all_protocols:       'Tous les protocoles',
        all_devices:         'Tous les équipements',
        all_categories:      'Toutes les catégories',
        all_severities:      'Toutes les sévérités',
        Critical_only:       'Critique & Erreur uniquement (Sev 0-3)',
        warnings_and_up:     'Avertissement & plus (Sev 0-4)',
        notifications_and_up:'Notice & plus (Sev 0-5)',
        info_and_up:         'Information & plus (Sev 0-6)',
        col_time:            'Horodatage',
        col_protocol:        'Protocole',
        col_severity:        'Sévérité',
        col_device:          'Équipement source',
        col_category:        'Catégorie',
        col_mnemonic:        'Mnémonique / OID Trap',
        col_message:         'Message d\'événement',
        no_messages:         'Aucun message Syslog ou Trap SNMP trouvé.',
        no_messages_hint:    'Dirigez vos routeurs/switchs vers le port UDP 514 (Syslog) ou UDP 162 (SNMP Trap), ou cliquez sur "Simuler un événement / Trap".',
        showing_count:       'Affichage de {shown} sur {total} messages',
        simulate_desc:       'Injectez un datagramme Syslog ou une PDU SNMP Trap pour tester l\'analyse et les alertes.',
        preset_template:     'Modèle d\'événement',
        protocol:            'Protocole',
        source_device:       'Équipement source',
        custom_ip:           'IP externe / personnalisée',
        source_ip:           'Adresse IP source',
        hostname:            'Nom d\'hôte',
        severity:            'Niveau de sévérité',
        category:            'Catégorie',
        mnemonic:            'Mnémonique Cisco / Identifiant',
        interface_opt:       'Interface (Optionnel)',
        message_body:        'Message Syslog / Résumé du Trap',
        send_simulation:     'Injecter l\'événement simulé',
        sim_sent_title:      'Événement injecté',
        sim_sent_desc:       'Le message Syslog/Trap simulé a été traité et enregistré.',
        cleared_title:       'Journaux purgés',
        cleared_desc:        '{count} entrées historiques supprimées.',
        detail_title:        'Inspection de l\'événement et du paquet',
        trap_oid:            'OID Trap SNMP',
        raw_payload:         'Charge utile brute (Raw Payload / VarBinds)',
    },
    topology: {
        title:               'Topologie Réseau',
        subtitle:            'Topologie L2/L3 auto-découverte et câblage des ports de switch via CDP, LLDP et télémétrie SNMP',
        nodes_count:         '{count} nœuds',
        links_count:         '{count} liens actifs',
        ports_count:         '{count} ports câblés',
        view_mode:           'Vue de la carte :',
        view_wiring:         'Schéma : Switch → MAC → Équipement',
        view_chassis:        'Face avant du switch (Faceplate)',
        view_ports:          'Carte Switchs & Ports',
        view_graph:          'Graphe Interactif',
        view_matrix:         'Matrice de Brassage (Ports)',
        filter_all:          'Tous',
        filter_switches:     'Switchs',
        filter_routers:      'Routeurs',
        filter_managed:      'Supervisés',
        search_placeholder:  'Filtrer nœuds, ports, alias ou IP...',
        reset_layout:        'Réinitialiser la vue',
        refresh_scan:        'Actualiser la topologie',
        scanning:            'Analyse des voisins CDP/LLDP et des ports...',
        legend_title:        'Légende de la topologie',
        legend_monitored:    'Supervisé (SNMP UP)',
        legend_external:     'Voisin CDP/LLDP',
        legend_offline:      'Alerte / Hors ligne',
        status_label:        'Statut du nœud',
        status_monitored:    'Équipement supervisé',
        status_external:     'Voisin découvert (CDP/LLDP)',
        type_label:          'Type d\'équipement',
        vendor_model:        'Constructeur & Modèle',
        open_in_devices:     'Ouvrir dans Équipements',
        connected_links:     'Liens et ports connectés ({count})',
        local_port:          'Port local',
        remote_port:         'Port distant',
        port_alias:          'Description / Alias du port',
        connected_device:    'Équipement connecté / Voisin',
        protocol:            'Protocole',
        speed_traffic:       'Vitesse & Trafic en direct',
        switch_chassis_desc: 'Ports physiques et LAG actifs avec voisins CDP/LLDP et descriptions SNMP',
        show_all_ports:      'Afficher tous les ports actifs',
        show_cdp_only:       'Voisins CDP / LLDP uniquement',
        no_links_found:      'Aucun lien trouvé pour ce filtre.',
        unidentified_peer:   'Lien actif',
        external_peers:      'Équipements et terminaux connectés découverts',
    },
    sensor_action: {
        ack_title:           'Acquitter l\'alerte du capteur (ACK)',
        ack_title_edit:      'Modifier l\'acquittement du capteur (ACK)',
        pause_title:         'Suspendre la surveillance du capteur',
        resume_title:        'Reprendre la surveillance du capteur',
        recorded_operator:   'Opérateur enregistré',
        logged_in:           'Connecté',
        comment_label_ack:   'Commentaire / motif de l\'acquittement',
        comment_label_pause: 'Motif de la suspension / maintenance',
        visible_to_team:     'Visible par toute l\'équipe',
        comment_ph_ack:      'ex. Travaux de liaison en cours, panne FAI signalée, remplacement matériel...',
        comment_ph_pause:    'ex. Maintenance planifiée, temporairement désactivé pour tests...',
        btn_clear_ack:       'Retirer ACK',
        btn_ack:             'Acquitter le capteur (ACK)',
        btn_update_comment:  'Enregistrer le commentaire',
        btn_pause:           'Suspendre',
        btn_resume:          'Reprendre',
        btn_resume_now:      'Reprendre maintenant',
        btn_acked:           'Acquitté',
        acked_by:            'Acquitté par',
        paused_by:           'Suspendu par',
        no_comment:          'Aucun commentaire',
        banner_acked:        'Alerte du capteur acquittée',
        banner_paused:       'Surveillance du capteur suspendue',
        edit_comment:        'Modifier le commentaire',
        clear_ack:           'Retirer ACK',
        success_ack:         'L\'alerte du capteur a été acquittée',
        success_unack:       'L\'acquittement du capteur a été retiré',
        success_pause:       'La surveillance du capteur est suspendue',
        success_resume:      'La surveillance du capteur a repris',
        presets: {
            maintenance:       'Maintenance réseau planifiée en cours',
            isp_outage:        'Panne FAI - ticket ouvert auprès de l\'opérateur',
            hardware_replace:  'En attente de remplacement matériel / SFP',
            known_issue:       'Problème identifié - analyse en cours',
            investigating:     'Alerte temporaire - surveillance active',
            pause_maintenance: 'Maintenance programmée de l\'équipement',
            pause_testing:     'Temporairement suspendu pour tests',
            pause_disabled:    'Équipement hors service jusqu\'à nouvel ordre',
            pause_customer:    'Accès client résilié',
            pause_monitoring:  'Supervision temporairement suspendue',
        },
    },
    inspector: {
        title_up:           'Capteurs et équipements opérationnels (UP)',
        title_down:         'Capteurs critiques et pannes (DOWN)',
        title_warning:      'Avertissements et capteurs dégradés (WARN)',
        title_ack:          'Capteurs acquittés (ACK)',
        title_paused:       'Capteurs suspendus / Maintenance (PAUSED)',
        title_unknown:      'Capteurs inconnus / non interrogés (UNKNOWN)',
        subtitle:           'Descriptions détaillées des capteurs, télémesures, acquittements (ACK) et motifs de suspension.',
        matching:           'correspondant(s)',
        close_filter:       'Fermer le filtre',
        search_placeholder: 'Rechercher capteur, équipement, commentaire ou utilisateur...',
        no_matching:        'Aucun capteur ou équipement ne correspond actuellement à ce statut',
        th_status:          'Statut',
        th_device:          'Équipement',
        th_sensor_name:     'Nom du capteur / nœud',
        th_type:            'Type',
        th_detail:          'Description & Détails ACK / Pause',
        th_reading:         'Mesure actuelle',
        th_last_checked:    'Dernière vérification',
        th_actions:         'Actions',
        inspect:            'Inspecter',
        clone_sensor:       'Dupliquer le capteur',
        showing:            'Affichage de',
        of:                 'sur',
        specs_title:        'Configuration du capteur & Seuils',
        sensor_id:          'ID capteur',
        check_interval:     'Intervalle de vérification',
        alarm_thresholds:   'Seuils d\'alarme',
        edit_thresholds:    'Modifier seuils / capteur',
    },
    bgp: {
        session_uptime:        'Disponibilité de session (Uptime)',
        remote_as:             'AS distant / Peer',
        asn_lookup_title:      'Recherche de Système Autonome (ASN)',
        asn_lookup_btn:        'Recherche AS',
        asn_input_placeholder: 'Entrez un numéro d\'AS (ex. 13335, AS5448, 65400)...',
        quick_presets:         'Sélection rapide:',
        querying_whois:        'Interrogation des registres WHOIS & RIPE Stat...',
        private_as:            'AS privé',
        public_as:             'AS public',
        network_type:          'Type de réseau',
        description:           'Description',
        external_tools:        'Looking Glass BGP externe & Outils',
        lookup_as:             'Consulter AS',
        enter_valid_as:        'Veuillez entrer un numéro d\'AS valide',
        asn_not_found:         'Impossible de résoudre les informations de l\'AS',
        network_error:         'Erreur réseau lors de la requête ASN',
        resolving:             'Résolution...',
        established:           'Établi',
    },
    scanner: {
        port_scan_title:      'Scan de Ports & Services',
        port_scan_hint:       'Découvre automatiquement les services ouverts (SSH, HTTP, DNS, Winbox, BGP) et crée un groupe de capteurs',
        profile:              'Profil de scan',
        profile_well_known:   'Services connus (~75 ports, <1s)',
        profile_common_1024:  'Ports standard 1-1024 (~1s)',
        profile_top_1000:     'Top 1000 ports (~2s)',
        scan_now:             'Scanner maintenant',
        enter_ip_first:       'Veuillez entrer une adresse IP avant de lancer le scan',
        scan_failed:          'Le scan de ports a échoué',
        found_ports:          '{count} ports ouverts détectés ({duration} ms)',
        no_open_ports:        'Aucun port ouvert trouvé',
        open_ports_tab:       'Ports ouverts & Services',
        open_ports_title:     'Ports ouverts & Services réseau',
        rescan_now:           'Scanner les ports',
        add_all_as_sensors:   'Ajouter tous comme capteurs',
        open_ports_count:     'Ports ouverts',
        scan_speed:           'Durée du dernier scan',
        target_ip:            'Adresse IP cible',
        active_sensors:       'Capteurs de ports actifs',
        search_placeholder:   'Rechercher par port, protocole ou service...',
        empty_hint:           'Aucun port ouvert enregistré pour cet équipement. Lancez un scan multithread rapide.',
        start_scan:           'Démarrer le scan de ports',
        col_port:             'Port / Protocole',
        col_service:          'Service',
        col_description:      'Description du service',
        col_latency:          'Latence',
        col_status:           'État',
        col_action:           'Capteur dans l\'arbre',
        sensor_active:        'Capteur actif',
        create_sensor:        'Ajouter le capteur',
        scan_completed:       '{count} ports ouverts trouvés en {duration}ms',
    },
}


